import { createActions, createReducer } from 'reduxsauce'
import Immutable, { type ImmutableObject } from 'seamless-immutable'

import type { DeeplinkState } from 'APP/Store/Deeplink/types'

const DEEPLINK_EXPIRY_HOURS = 1

/* ------------- Types and Action Creators ------------- */

const actionDefs = {
  setReadyToProcess: ['ready'],
  setDeferredDeeplink: ['path', 'props'],
  rejectDeferredDeeplink: ['reason', 'path', 'props'],
  processDeferredDeeplink: null,
  processDeferredDeeplinkSuccess: null,
  processDeferredDeeplinkFailure: ['error'],
  processDeferredDeeplinkExpired: null,
  setDeeplinkPath: ['path'],
}

type TActions = typeof actionDefs
type TPayloads = {}

const { Types, Creators } = createActions<TPayloads, TActions>(actionDefs)

type ImmutableDeeplinkState = ImmutableObject<DeeplinkState>

export const INITIAL_STATE = Immutable<DeeplinkState>({
  readyToProcess: false,
  path: null,
  props: {},
  deferredLinkRejected: false,
  reason: null,
})

export const setReadyToProcess = (
  state: ImmutableDeeplinkState,
  { ready }: { ready: DeeplinkState['readyToProcess'] }
) =>
  state.merge({
    readyToProcess: ready,
  })

export const setDeeplinkPath = (
  state: ImmutableDeeplinkState,
  { path }: { path: DeeplinkState['path'] }
) => state.merge({ path })

export const setDeferredDeeplink = (
  state: ImmutableDeeplinkState,
  { path, props }: { path: DeeplinkState['path']; props: DeeplinkState['props'] }
) => {
  let expiry = new Date()
  expiry.setHours(expiry.getHours() + DEEPLINK_EXPIRY_HOURS)

  return state.merge(
    {
      path,
      props,
      deferredLinkRejected: false,
      reason: null,
      expiry,
    },
    { deep: true }
  )
}

export const clearDeferredDeeplinkState = (state: ImmutableDeeplinkState) =>
  state.merge({
    path: null,
    props: {},
  })

export const rejectDeferredDeeplink = (
  state: ImmutableDeeplinkState,
  { reason }: { reason: DeeplinkState['reason'] }
) => clearDeferredDeeplinkState(state).merge({ deferredLinkRejected: true, reason })

export const DeeplinkTypes = Types

export default Creators

export const reducer = createReducer<TPayloads, TActions, ImmutableDeeplinkState>(INITIAL_STATE, {
  // @ts-expect-error TODO: write payload model for action & add it to TPayloads
  [Types.SET_READY_TO_PROCESS]: setReadyToProcess,
  // @ts-expect-error TODO: write payload model for action & add it to TPayloads
  [Types.SET_DEFERRED_DEEPLINK]: setDeferredDeeplink,
  // @ts-expect-error TODO: write payload model for action & add it to TPayloads
  [Types.SET_DEEPLINK_PATH]: setDeeplinkPath,
  [Types.PROCESS_DEFERRED_DEEPLINK_SUCCESS]: clearDeferredDeeplinkState,
  // @ts-expect-error TODO: write payload model for action & add it to TPayloads
  [Types.PROCESS_DEFERRED_DEEPLINK_FAILURE]: clearDeferredDeeplinkState,
  [Types.PROCESS_DEFERRED_DEEPLINK_EXPIRED]: clearDeferredDeeplinkState,
  // @ts-expect-error TODO: write payload model for action & add it to TPayloads
  [Types.REJECT_DEFERRED_DEEPLINK]: rejectDeferredDeeplink,
})
